
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404IzsWmT2T_2IFGkO7Wec6MIQRMM22i_i9Pz9KBcKmkTQMeta } from "/usr/src/app/pages/404.vue?macro=true";
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as about_45usX3uyY7bIkb8hiCCU_3JfvU2CD1RFMIxAJvlf7U_45qunEMeta } from "/usr/src/app/pages/about-us.vue?macro=true";
import { default as warrantybfRv8dzKngd2gaX8LwMHxiHCVVYHbqJheqtkj52VJ0QMeta } from "/usr/src/app/pages/warranty.vue?macro=true";
import { default as _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
import { default as index5dMHWws_45hSqaY_45b_avLzusRo34ibhvseGOwRLE4hyfQMeta } from "/usr/src/app/pages/faq/index.vue?macro=true";
import { default as indexDc9HC8_45vQ1YA4SSTlv0i2oi0JlVwOeS5e30xp8QGI7MMeta } from "/usr/src/app/pages/pro/index.vue?macro=true";
import { default as all_45brands7TAJAHrdbSxAS8oKkhw4iF9lTJPwXBGCq6p_I7TiNYMMeta } from "/usr/src/app/pages/all-brands.vue?macro=true";
import { default as indexb9dLhWKV_hdZEkwDWzx2yuGS_ZBLlFnH6n0WnvGlgNcMeta } from "/usr/src/app/pages/blog/index.vue?macro=true";
import { default as index1kKK7j40Y60jCE_45bYIzoEtgKqpoWCC_N6D5sY2nuIbgMeta } from "/usr/src/app/pages/cart/index.vue?macro=true";
import { default as claim_45formfoblWQwg5TX3iD0rXGUSYxVcOTZAmaLLnQd0ko_puYwMeta } from "/usr/src/app/pages/claim-form.vue?macro=true";
import { default as _91slug_93Rn0XcOXAjun86skiksRGnj_6FDyTPP2nh_ME90kxZ6cMeta } from "/usr/src/app/pages/faq/[slug].vue?macro=true";
import { default as _91slug_93RDa6imw48EDyei7f0gx9ZCMNWahDgy9GpYYgaEbeIOwMeta } from "/usr/src/app/pages/blog/[slug].vue?macro=true";
import { default as _91_46_46_46slug_933bcZ0CSmAtKT3AKtAWDjn7mqzx9NDj5ux7ZRbDK_FUIMeta } from "/usr/src/app/pages/c/[...slug].vue?macro=true";
import { default as indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta } from "/usr/src/app/pages/login/index.vue?macro=true";
import { default as _91_46_46_46slug_934C8AsQXR8VehnCgndjXG0IRI4pno_VcEqTu16tBAA14Meta } from "/usr/src/app/pages/p/[...slug].vue?macro=true";
import { default as _91id_93q78PorsaM6zHE_rRv8qDngc3Vazf7IU_45Ts5bbJnnNv0Meta } from "/usr/src/app/pages/invoice/[id].vue?macro=true";
import { default as failyGyjPoQlOJRdp2AhJniRdrVL4jjpLPaIfV_45l9_fVqVYMeta } from "/usr/src/app/pages/payment/fail.vue?macro=true";
import { default as indexmVTYKSVK0nOpkoHoYy991vX1fZTTbU78hfz0tzQBXSQMeta } from "/usr/src/app/pages/quotes/index.vue?macro=true";
import { default as indexEcmj70l3mC3Kvb_u2ubrbn8pAXFE3Y__dIu5J6mWmSQMeta } from "/usr/src/app/pages/search/index.vue?macro=true";
import { default as indexqiEKw9w7zKaWp62n_4595tEVnRWVFFYiPl3ceVDSD5wLEMeta } from "/usr/src/app/pages/status/index.vue?macro=true";
import { default as indexcUkadVVr3MoxZJ95Rfj_45XDg0sVtPUem2rG_45Ml7X0_lIMeta } from "/usr/src/app/pages/confirm/index.vue?macro=true";
import { default as indexcz_IQP_70TQ98f0VrBAsHgxYkI3uGU0HdE2d9IJRLTkMeta } from "/usr/src/app/pages/payment/index.vue?macro=true";
import { default as _91slug_93KYYUNGGus1szFFkdAGsfDeQV2wCGfKrIBYxaI4A5L4YMeta } from "/usr/src/app/pages/quotes/[slug].vue?macro=true";
import { default as indexPeg1_45XdpUNx4RXRnOv01q4m7YA2Bh3hQfxyvHTuewtQMeta } from "/usr/src/app/pages/success/index.vue?macro=true";
import { default as _91id_93OSoxT6jjIjBbwod0efEjhz3eUTVWYcBxgRJJB_EYFBIMeta } from "/usr/src/app/pages/tracking/[id].vue?macro=true";
import { default as indexmlNbK9lsJsHfHo1bbibg_458vKno3d_45iLweNcsQj0m8PUMeta } from "/usr/src/app/pages/checkout/index.vue?macro=true";
import { default as claim_45form_45proRXjnhqTM6zLQdy3ETqO6stXCwrBFTFaKQeJkX4wwssAMeta } from "/usr/src/app/pages/claim-form-pro.vue?macro=true";
import { default as indexQ6GMvaN00UbY4hur5ZSdvVsVVGs3YNtH5rSLFnbd_6EMeta } from "/usr/src/app/pages/contacts/index.vue?macro=true";
import { default as index_9yHCMiXOR_45w3nsScfz2IHZO6QiRAHRQevko7x1nUIUMeta } from "/usr/src/app/pages/dealzone/index.vue?macro=true";
import { default as acceptX4knTauEjWk9JY_zixOxNpphg3bO5QiPbpq7MDzf3NUMeta } from "/usr/src/app/pages/invoice/accept.vue?macro=true";
import { default as acceptSDeCHcFqnDWT_AoZvUuTC5kgUwSkvKLoIMHyHvu0KHsMeta } from "/usr/src/app/pages/payment/accept.vue?macro=true";
import { default as indexZD4lmZeHNbgAJdSp25r_Wap6KrejWKH0HywWvtSyP0UMeta } from "/usr/src/app/pages/register/index.vue?macro=true";
import { default as indexqdDtuZZGESq61iOmdhmp_45sb_DJveaxaVxDQ_45ZrsP8FAMeta } from "/usr/src/app/pages/site-pro/index.vue?macro=true";
import { default as indexK_45mrHozcdij_45uH8reV_MEyV_45NzXk355V1GQ9Dbli7esMeta } from "/usr/src/app/pages/tracking/index.vue?macro=true";
import { default as decliney79Yqmk9EpqQpIhSuYjVzy163NrH7exHC4x7XQsU4DMMeta } from "/usr/src/app/pages/invoice/decline.vue?macro=true";
import { default as indexROTz5finYF5_j3Pt7XtreI5NTtbtknX_45zLxWFQiAqJgMeta } from "/usr/src/app/pages/my-orders/index.vue?macro=true";
import { default as declinexvQC7dxwOdy5fjygJgIT3rJj8jla450ZNEy7FxhwwIIMeta } from "/usr/src/app/pages/payment/decline.vue?macro=true";
import { default as _91_91slug_93_93PXefAvRvRrD6c4RIrEEP_45u_UAeBjt9LBU2n9iLCwWysMeta } from "/usr/src/app/pages/confirm/[[slug]].vue?macro=true";
import { default as indexmnsZT4ih3k_45jXR8WcxBZBDtTPB_C1Y5WYNmpIGS8bB4Meta } from "/usr/src/app/pages/order-form/index.vue?macro=true";
import { default as order_45successful2eaUNAt_45EOU1aygcCQH2xohESEqnR9G_pThsO61R_45G8Meta } from "/usr/src/app/pages/order-successful.vue?macro=true";
import { default as _91_91slug_93_93FzCbuEHRtDcLJwiJsa1pTBTIhm5Z4dK7xrP9cLI6zZ8Meta } from "/usr/src/app/pages/payment/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93xgkmO_45d2xgLMJHj_vTZivkxFa8vu_eFTsmzdZ_45YGWocMeta } from "/usr/src/app/pages/success/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93mfh_ddLJR_45lhvSnBAbPnECTkL96rT7XH_456wzO2x6CMcMeta } from "/usr/src/app/pages/checkout/[[slug]].vue?macro=true";
import { default as indexnsl_tZSTRK0iHJvhcKq_45PDBBxOTMS0lxZTsIqhgg98oMeta } from "/usr/src/app/pages/marketplace/index.vue?macro=true";
import { default as indexZkfLdxBIxziNWE6BzJ4CTAKfqgenkyG1rMNtoxOR0QcMeta } from "/usr/src/app/pages/user-account/index.vue?macro=true";
import { default as _91_46_46_46slug_93fA1K73vh2O__wpmvdrMRC61kYP4XLMtluku3QCmXVAwMeta } from "/usr/src/app/pages/my-orders/[...slug].vue?macro=true";
import { default as successdPPYc3XYEvjazZBZmlOMN8TH8morYDOOXC60oEOnvpoMeta } from "/usr/src/app/pages/reservation/success.vue?macro=true";
import { default as unsupported_45browserJT_45rVOpsUVaHhFshp10whMb6lIdfbtkwvDRcvk_45BOIAMeta } from "/usr/src/app/pages/unsupported-browser.vue?macro=true";
import { default as indexV3keO9i30VjIGfS1JklNbFCLHu93Km5X_45K9FD62H_i8Meta } from "/usr/src/app/pages/privacy-policy/index.vue?macro=true";
import { default as _91_46_46_46slug_93bJfjcSmPyANKO9Nvl8fsGEzfre_XxVxdmjDbe_MRKkwMeta } from "/usr/src/app/pages/create-order/[...slug].vue?macro=true";
import { default as indextCDMJjLU6HgoAgAihBEEMu4VyJ7NS2zK_i43YcvP_ZEMeta } from "/usr/src/app/pages/site-pro-delivery/index.vue?macro=true";
import { default as indexCxMSchgRpTGp3uFVrqOFXy58Y3pxatgetJKS_45O0MvvAMeta } from "/usr/src/app/pages/delivery-addresses/index.vue?macro=true";
import { default as indexAKi0q5fmY1zcQW_CMZoENv3Jsy_TA153g_8H04Esb9YMeta } from "/usr/src/app/pages/iphone-reservation/index.vue?macro=true";
import { default as _91_46_46_46slug_93jdGPOZba2aDFdbpQeMLuAZlRBAL4lgCAIO3kEvNlylkMeta } from "/usr/src/app/pages/market/product/[...slug].vue?macro=true";
import { default as indexQwwG2bX5qiWOJdk_45WtqWU9tHZySzOU8F7NCdCH7NN6wMeta } from "/usr/src/app/pages/order-form/summary/index.vue?macro=true";
import { default as indexOm2FQi1kF_bywg7pe_7xMSfJ40sHJ50Am4XNT_TutMQMeta } from "/usr/src/app/pages/purchase-agreement/index.vue?macro=true";
import { default as indexIy4fmF2rXQSX0kl_455zojGRk59eQZiQ3MaGo_psmxyjwMeta } from "/usr/src/app/pages/reservation-policy/index.vue?macro=true";
import { default as _91_46_46_46id_93ODBAiS3qqex7f_DgxzHBkFnPjyjS_45HFUO7Ey9SAxl0EMeta } from "/usr/src/app/pages/site-pro-payment/[...id].vue?macro=true";
import { default as indext5SkrhmkX9t59W4CPgaftuV9_45_45u690vTImE6czlTvaMMeta } from "/usr/src/app/pages/account-information/index.vue?macro=true";
import { default as _91_46_46_46token_93hx_45yjPPpR_45KPk0_CoFoS6NhfPF57cVowMT_45edROkHbQMeta } from "/usr/src/app/pages/password-reset/[...token].vue?macro=true";
import { default as _91id_93OJ56Afegb3RMtmxRghDvwUXLeWkezxAIjX6N7Z3XasMMeta } from "/usr/src/app/pages/iphone-reservation/confirm/[id].vue?macro=true";
import { default as _91_46_46_46slug_93ynHhnfxt_AoE3NrkUyBIHpmmtdOxju7_UJCy0BEDFvQMeta } from "/usr/src/app/pages/order-additional-info-needed/[...slug].vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404IzsWmT2T_2IFGkO7Wec6MIQRMM22i_i9Pz9KBcKmkTQMeta || {},
    component: () => import("/usr/src/app/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: about_45usX3uyY7bIkb8hiCCU_3JfvU2CD1RFMIxAJvlf7U_45qunEMeta || {},
    component: () => import("/usr/src/app/pages/about-us.vue")
  },
  {
    name: "warranty",
    path: "/warranty",
    component: () => import("/usr/src/app/pages/warranty.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: index5dMHWws_45hSqaY_45b_avLzusRo34ibhvseGOwRLE4hyfQMeta || {},
    component: () => import("/usr/src/app/pages/faq/index.vue")
  },
  {
    name: "pro",
    path: "/pro",
    meta: indexDc9HC8_45vQ1YA4SSTlv0i2oi0JlVwOeS5e30xp8QGI7MMeta || {},
    component: () => import("/usr/src/app/pages/pro/index.vue")
  },
  {
    name: "all-brands",
    path: "/all-brands",
    meta: all_45brands7TAJAHrdbSxAS8oKkhw4iF9lTJPwXBGCq6p_I7TiNYMMeta || {},
    component: () => import("/usr/src/app/pages/all-brands.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexb9dLhWKV_hdZEkwDWzx2yuGS_ZBLlFnH6n0WnvGlgNcMeta || {},
    component: () => import("/usr/src/app/pages/blog/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: index1kKK7j40Y60jCE_45bYIzoEtgKqpoWCC_N6D5sY2nuIbgMeta || {},
    component: () => import("/usr/src/app/pages/cart/index.vue")
  },
  {
    name: "claim-form",
    path: "/claim-form",
    component: () => import("/usr/src/app/pages/claim-form.vue")
  },
  {
    name: "faq-slug",
    path: "/faq/:slug()",
    meta: _91slug_93Rn0XcOXAjun86skiksRGnj_6FDyTPP2nh_ME90kxZ6cMeta || {},
    component: () => import("/usr/src/app/pages/faq/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/usr/src/app/pages/blog/[slug].vue")
  },
  {
    name: "c-slug",
    path: "/c/:slug(.*)*",
    meta: _91_46_46_46slug_933bcZ0CSmAtKT3AKtAWDjn7mqzx9NDj5ux7ZRbDK_FUIMeta || {},
    component: () => import("/usr/src/app/pages/c/[...slug].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta || {},
    component: () => import("/usr/src/app/pages/login/index.vue")
  },
  {
    name: "p-slug",
    path: "/p/:slug(.*)*",
    meta: _91_46_46_46slug_934C8AsQXR8VehnCgndjXG0IRI4pno_VcEqTu16tBAA14Meta || {},
    component: () => import("/usr/src/app/pages/p/[...slug].vue")
  },
  {
    name: "invoice-id",
    path: "/invoice/:id()",
    component: () => import("/usr/src/app/pages/invoice/[id].vue")
  },
  {
    name: "payment-fail",
    path: "/payment/fail",
    meta: failyGyjPoQlOJRdp2AhJniRdrVL4jjpLPaIfV_45l9_fVqVYMeta || {},
    component: () => import("/usr/src/app/pages/payment/fail.vue")
  },
  {
    name: "quotes",
    path: "/quotes",
    meta: indexmVTYKSVK0nOpkoHoYy991vX1fZTTbU78hfz0tzQBXSQMeta || {},
    component: () => import("/usr/src/app/pages/quotes/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexEcmj70l3mC3Kvb_u2ubrbn8pAXFE3Y__dIu5J6mWmSQMeta || {},
    component: () => import("/usr/src/app/pages/search/index.vue")
  },
  {
    name: "status",
    path: "/status",
    component: () => import("/usr/src/app/pages/status/index.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    meta: indexcUkadVVr3MoxZJ95Rfj_45XDg0sVtPUem2rG_45Ml7X0_lIMeta || {},
    component: () => import("/usr/src/app/pages/confirm/index.vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: indexcz_IQP_70TQ98f0VrBAsHgxYkI3uGU0HdE2d9IJRLTkMeta || {},
    component: () => import("/usr/src/app/pages/payment/index.vue")
  },
  {
    name: "quotes-slug",
    path: "/quotes/:slug()",
    meta: _91slug_93KYYUNGGus1szFFkdAGsfDeQV2wCGfKrIBYxaI4A5L4YMeta || {},
    component: () => import("/usr/src/app/pages/quotes/[slug].vue")
  },
  {
    name: "success",
    path: "/success",
    meta: indexPeg1_45XdpUNx4RXRnOv01q4m7YA2Bh3hQfxyvHTuewtQMeta || {},
    component: () => import("/usr/src/app/pages/success/index.vue")
  },
  {
    name: "tracking-id",
    path: "/tracking/:id()",
    meta: _91id_93OSoxT6jjIjBbwod0efEjhz3eUTVWYcBxgRJJB_EYFBIMeta || {},
    component: () => import("/usr/src/app/pages/tracking/[id].vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: indexmlNbK9lsJsHfHo1bbibg_458vKno3d_45iLweNcsQj0m8PUMeta || {},
    component: () => import("/usr/src/app/pages/checkout/index.vue")
  },
  {
    name: "claim-form-pro",
    path: "/claim-form-pro",
    meta: claim_45form_45proRXjnhqTM6zLQdy3ETqO6stXCwrBFTFaKQeJkX4wwssAMeta || {},
    component: () => import("/usr/src/app/pages/claim-form-pro.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    meta: indexQ6GMvaN00UbY4hur5ZSdvVsVVGs3YNtH5rSLFnbd_6EMeta || {},
    component: () => import("/usr/src/app/pages/contacts/index.vue")
  },
  {
    name: "dealzone",
    path: "/dealzone",
    meta: index_9yHCMiXOR_45w3nsScfz2IHZO6QiRAHRQevko7x1nUIUMeta || {},
    component: () => import("/usr/src/app/pages/dealzone/index.vue")
  },
  {
    name: "invoice-accept",
    path: "/invoice/accept",
    meta: acceptX4knTauEjWk9JY_zixOxNpphg3bO5QiPbpq7MDzf3NUMeta || {},
    component: () => import("/usr/src/app/pages/invoice/accept.vue")
  },
  {
    name: "payment-accept",
    path: "/payment/accept",
    meta: acceptSDeCHcFqnDWT_AoZvUuTC5kgUwSkvKLoIMHyHvu0KHsMeta || {},
    component: () => import("/usr/src/app/pages/payment/accept.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexZD4lmZeHNbgAJdSp25r_Wap6KrejWKH0HywWvtSyP0UMeta || {},
    component: () => import("/usr/src/app/pages/register/index.vue")
  },
  {
    name: "site-pro",
    path: "/site-pro",
    meta: indexqdDtuZZGESq61iOmdhmp_45sb_DJveaxaVxDQ_45ZrsP8FAMeta || {},
    component: () => import("/usr/src/app/pages/site-pro/index.vue")
  },
  {
    name: "tracking",
    path: "/tracking",
    meta: indexK_45mrHozcdij_45uH8reV_MEyV_45NzXk355V1GQ9Dbli7esMeta || {},
    component: () => import("/usr/src/app/pages/tracking/index.vue")
  },
  {
    name: "invoice-decline",
    path: "/invoice/decline",
    meta: decliney79Yqmk9EpqQpIhSuYjVzy163NrH7exHC4x7XQsU4DMMeta || {},
    component: () => import("/usr/src/app/pages/invoice/decline.vue")
  },
  {
    name: "my-orders",
    path: "/my-orders",
    meta: indexROTz5finYF5_j3Pt7XtreI5NTtbtknX_45zLxWFQiAqJgMeta || {},
    component: () => import("/usr/src/app/pages/my-orders/index.vue")
  },
  {
    name: "payment-decline",
    path: "/payment/decline",
    meta: declinexvQC7dxwOdy5fjygJgIT3rJj8jla450ZNEy7FxhwwIIMeta || {},
    component: () => import("/usr/src/app/pages/payment/decline.vue")
  },
  {
    name: "confirm-slug",
    path: "/confirm/:slug?",
    meta: _91_91slug_93_93PXefAvRvRrD6c4RIrEEP_45u_UAeBjt9LBU2n9iLCwWysMeta || {},
    component: () => import("/usr/src/app/pages/confirm/[[slug]].vue")
  },
  {
    name: "order-form",
    path: "/order-form",
    meta: indexmnsZT4ih3k_45jXR8WcxBZBDtTPB_C1Y5WYNmpIGS8bB4Meta || {},
    component: () => import("/usr/src/app/pages/order-form/index.vue")
  },
  {
    name: "order-successful",
    path: "/order-successful",
    meta: order_45successful2eaUNAt_45EOU1aygcCQH2xohESEqnR9G_pThsO61R_45G8Meta || {},
    component: () => import("/usr/src/app/pages/order-successful.vue")
  },
  {
    name: "payment-slug",
    path: "/payment/:slug?",
    meta: _91_91slug_93_93FzCbuEHRtDcLJwiJsa1pTBTIhm5Z4dK7xrP9cLI6zZ8Meta || {},
    component: () => import("/usr/src/app/pages/payment/[[slug]].vue")
  },
  {
    name: "success-slug",
    path: "/success/:slug?",
    meta: _91_91slug_93_93xgkmO_45d2xgLMJHj_vTZivkxFa8vu_eFTsmzdZ_45YGWocMeta || {},
    component: () => import("/usr/src/app/pages/success/[[slug]].vue")
  },
  {
    name: "checkout-slug",
    path: "/checkout/:slug?",
    meta: _91_91slug_93_93mfh_ddLJR_45lhvSnBAbPnECTkL96rT7XH_456wzO2x6CMcMeta || {},
    component: () => import("/usr/src/app/pages/checkout/[[slug]].vue")
  },
  {
    name: "marketplace",
    path: "/marketplace",
    meta: indexnsl_tZSTRK0iHJvhcKq_45PDBBxOTMS0lxZTsIqhgg98oMeta || {},
    component: () => import("/usr/src/app/pages/marketplace/index.vue")
  },
  {
    name: "user-account",
    path: "/user-account",
    meta: indexZkfLdxBIxziNWE6BzJ4CTAKfqgenkyG1rMNtoxOR0QcMeta || {},
    component: () => import("/usr/src/app/pages/user-account/index.vue")
  },
  {
    name: "my-orders-slug",
    path: "/my-orders/:slug(.*)*",
    meta: _91_46_46_46slug_93fA1K73vh2O__wpmvdrMRC61kYP4XLMtluku3QCmXVAwMeta || {},
    component: () => import("/usr/src/app/pages/my-orders/[...slug].vue")
  },
  {
    name: "reservation-success",
    path: "/reservation/success",
    meta: successdPPYc3XYEvjazZBZmlOMN8TH8morYDOOXC60oEOnvpoMeta || {},
    component: () => import("/usr/src/app/pages/reservation/success.vue")
  },
  {
    name: "unsupported-browser",
    path: "/unsupported-browser",
    meta: unsupported_45browserJT_45rVOpsUVaHhFshp10whMb6lIdfbtkwvDRcvk_45BOIAMeta || {},
    component: () => import("/usr/src/app/pages/unsupported-browser.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexV3keO9i30VjIGfS1JklNbFCLHu93Km5X_45K9FD62H_i8Meta || {},
    component: () => import("/usr/src/app/pages/privacy-policy/index.vue")
  },
  {
    name: "create-order-slug",
    path: "/create-order/:slug(.*)*",
    meta: _91_46_46_46slug_93bJfjcSmPyANKO9Nvl8fsGEzfre_XxVxdmjDbe_MRKkwMeta || {},
    component: () => import("/usr/src/app/pages/create-order/[...slug].vue")
  },
  {
    name: "site-pro-delivery",
    path: "/site-pro-delivery",
    meta: indextCDMJjLU6HgoAgAihBEEMu4VyJ7NS2zK_i43YcvP_ZEMeta || {},
    component: () => import("/usr/src/app/pages/site-pro-delivery/index.vue")
  },
  {
    name: "delivery-addresses",
    path: "/delivery-addresses",
    meta: indexCxMSchgRpTGp3uFVrqOFXy58Y3pxatgetJKS_45O0MvvAMeta || {},
    component: () => import("/usr/src/app/pages/delivery-addresses/index.vue")
  },
  {
    name: "iphone-reservation",
    path: "/iphone-reservation",
    meta: indexAKi0q5fmY1zcQW_CMZoENv3Jsy_TA153g_8H04Esb9YMeta || {},
    component: () => import("/usr/src/app/pages/iphone-reservation/index.vue")
  },
  {
    name: "market-product-slug",
    path: "/market/product/:slug(.*)*",
    component: () => import("/usr/src/app/pages/market/product/[...slug].vue")
  },
  {
    name: "order-form-summary",
    path: "/order-form/summary",
    meta: indexQwwG2bX5qiWOJdk_45WtqWU9tHZySzOU8F7NCdCH7NN6wMeta || {},
    component: () => import("/usr/src/app/pages/order-form/summary/index.vue")
  },
  {
    name: "purchase-agreement",
    path: "/purchase-agreement",
    meta: indexOm2FQi1kF_bywg7pe_7xMSfJ40sHJ50Am4XNT_TutMQMeta || {},
    component: () => import("/usr/src/app/pages/purchase-agreement/index.vue")
  },
  {
    name: "reservation-policy",
    path: "/reservation-policy",
    meta: indexIy4fmF2rXQSX0kl_455zojGRk59eQZiQ3MaGo_psmxyjwMeta || {},
    component: () => import("/usr/src/app/pages/reservation-policy/index.vue")
  },
  {
    name: "site-pro-payment-id",
    path: "/site-pro-payment/:id(.*)*",
    meta: _91_46_46_46id_93ODBAiS3qqex7f_DgxzHBkFnPjyjS_45HFUO7Ey9SAxl0EMeta || {},
    component: () => import("/usr/src/app/pages/site-pro-payment/[...id].vue")
  },
  {
    name: "account-information",
    path: "/account-information",
    meta: indext5SkrhmkX9t59W4CPgaftuV9_45_45u690vTImE6czlTvaMMeta || {},
    component: () => import("/usr/src/app/pages/account-information/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token(.*)*",
    meta: _91_46_46_46token_93hx_45yjPPpR_45KPk0_CoFoS6NhfPF57cVowMT_45edROkHbQMeta || {},
    component: () => import("/usr/src/app/pages/password-reset/[...token].vue")
  },
  {
    name: "iphone-reservation-confirm-id",
    path: "/iphone-reservation/confirm/:id()",
    meta: _91id_93OJ56Afegb3RMtmxRghDvwUXLeWkezxAIjX6N7Z3XasMMeta || {},
    component: () => import("/usr/src/app/pages/iphone-reservation/confirm/[id].vue")
  },
  {
    name: "order-additional-info-needed-slug",
    path: "/order-additional-info-needed/:slug(.*)*",
    meta: _91_46_46_46slug_93ynHhnfxt_AoE3NrkUyBIHpmmtdOxju7_UJCy0BEDFvQMeta || {},
    component: () => import("/usr/src/app/pages/order-additional-info-needed/[...slug].vue")
  },
  {
    name: "locale-404",
    path: "/:locale/404",
    meta: _404IzsWmT2T_2IFGkO7Wec6MIQRMM22i_i9Pz9KBcKmkTQMeta || {},
    component: () => import("/usr/src/app/pages/404.vue")
  },
  {
    name: "locale-index",
    path: "/:locale/",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "locale-about-us",
    path: "/:locale/about-us",
    meta: about_45usX3uyY7bIkb8hiCCU_3JfvU2CD1RFMIxAJvlf7U_45qunEMeta || {},
    component: () => import("/usr/src/app/pages/about-us.vue")
  },
  {
    name: "locale-warranty",
    path: "/:locale/warranty",
    component: () => import("/usr/src/app/pages/warranty.vue")
  },
  {
    name: "locale-slug",
    path: "/:locale/:slug(.*)*",
    meta: _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "locale-faq",
    path: "/:locale/faq",
    meta: index5dMHWws_45hSqaY_45b_avLzusRo34ibhvseGOwRLE4hyfQMeta || {},
    component: () => import("/usr/src/app/pages/faq/index.vue")
  },
  {
    name: "locale-pro",
    path: "/:locale/pro",
    meta: indexDc9HC8_45vQ1YA4SSTlv0i2oi0JlVwOeS5e30xp8QGI7MMeta || {},
    component: () => import("/usr/src/app/pages/pro/index.vue")
  },
  {
    name: "locale-all-brands",
    path: "/:locale/all-brands",
    meta: all_45brands7TAJAHrdbSxAS8oKkhw4iF9lTJPwXBGCq6p_I7TiNYMMeta || {},
    component: () => import("/usr/src/app/pages/all-brands.vue")
  },
  {
    name: "locale-blog",
    path: "/:locale/blog",
    meta: indexb9dLhWKV_hdZEkwDWzx2yuGS_ZBLlFnH6n0WnvGlgNcMeta || {},
    component: () => import("/usr/src/app/pages/blog/index.vue")
  },
  {
    name: "locale-cart",
    path: "/:locale/cart",
    meta: index1kKK7j40Y60jCE_45bYIzoEtgKqpoWCC_N6D5sY2nuIbgMeta || {},
    component: () => import("/usr/src/app/pages/cart/index.vue")
  },
  {
    name: "locale-claim-form",
    path: "/:locale/claim-form",
    component: () => import("/usr/src/app/pages/claim-form.vue")
  },
  {
    name: "locale-faq-slug",
    path: "/:locale/faq/:slug()",
    meta: _91slug_93Rn0XcOXAjun86skiksRGnj_6FDyTPP2nh_ME90kxZ6cMeta || {},
    component: () => import("/usr/src/app/pages/faq/[slug].vue")
  },
  {
    name: "locale-blog-slug",
    path: "/:locale/blog/:slug()",
    component: () => import("/usr/src/app/pages/blog/[slug].vue")
  },
  {
    name: "locale-c-slug",
    path: "/:locale/c/:slug(.*)*",
    meta: _91_46_46_46slug_933bcZ0CSmAtKT3AKtAWDjn7mqzx9NDj5ux7ZRbDK_FUIMeta || {},
    component: () => import("/usr/src/app/pages/c/[...slug].vue")
  },
  {
    name: "locale-login",
    path: "/:locale/login",
    meta: indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta || {},
    component: () => import("/usr/src/app/pages/login/index.vue")
  },
  {
    name: "locale-p-slug",
    path: "/:locale/p/:slug(.*)*",
    meta: _91_46_46_46slug_934C8AsQXR8VehnCgndjXG0IRI4pno_VcEqTu16tBAA14Meta || {},
    component: () => import("/usr/src/app/pages/p/[...slug].vue")
  },
  {
    name: "locale-invoice-id",
    path: "/:locale/invoice/:id()",
    component: () => import("/usr/src/app/pages/invoice/[id].vue")
  },
  {
    name: "locale-payment-fail",
    path: "/:locale/payment/fail",
    meta: failyGyjPoQlOJRdp2AhJniRdrVL4jjpLPaIfV_45l9_fVqVYMeta || {},
    component: () => import("/usr/src/app/pages/payment/fail.vue")
  },
  {
    name: "locale-quotes",
    path: "/:locale/quotes",
    meta: indexmVTYKSVK0nOpkoHoYy991vX1fZTTbU78hfz0tzQBXSQMeta || {},
    component: () => import("/usr/src/app/pages/quotes/index.vue")
  },
  {
    name: "locale-search",
    path: "/:locale/search",
    meta: indexEcmj70l3mC3Kvb_u2ubrbn8pAXFE3Y__dIu5J6mWmSQMeta || {},
    component: () => import("/usr/src/app/pages/search/index.vue")
  },
  {
    name: "locale-status",
    path: "/:locale/status",
    component: () => import("/usr/src/app/pages/status/index.vue")
  },
  {
    name: "locale-confirm",
    path: "/:locale/confirm",
    meta: indexcUkadVVr3MoxZJ95Rfj_45XDg0sVtPUem2rG_45Ml7X0_lIMeta || {},
    component: () => import("/usr/src/app/pages/confirm/index.vue")
  },
  {
    name: "locale-payment",
    path: "/:locale/payment",
    meta: indexcz_IQP_70TQ98f0VrBAsHgxYkI3uGU0HdE2d9IJRLTkMeta || {},
    component: () => import("/usr/src/app/pages/payment/index.vue")
  },
  {
    name: "locale-quotes-slug",
    path: "/:locale/quotes/:slug()",
    meta: _91slug_93KYYUNGGus1szFFkdAGsfDeQV2wCGfKrIBYxaI4A5L4YMeta || {},
    component: () => import("/usr/src/app/pages/quotes/[slug].vue")
  },
  {
    name: "locale-success",
    path: "/:locale/success",
    meta: indexPeg1_45XdpUNx4RXRnOv01q4m7YA2Bh3hQfxyvHTuewtQMeta || {},
    component: () => import("/usr/src/app/pages/success/index.vue")
  },
  {
    name: "locale-tracking-id",
    path: "/:locale/tracking/:id()",
    meta: _91id_93OSoxT6jjIjBbwod0efEjhz3eUTVWYcBxgRJJB_EYFBIMeta || {},
    component: () => import("/usr/src/app/pages/tracking/[id].vue")
  },
  {
    name: "locale-checkout",
    path: "/:locale/checkout",
    meta: indexmlNbK9lsJsHfHo1bbibg_458vKno3d_45iLweNcsQj0m8PUMeta || {},
    component: () => import("/usr/src/app/pages/checkout/index.vue")
  },
  {
    name: "locale-claim-form-pro",
    path: "/:locale/claim-form-pro",
    meta: claim_45form_45proRXjnhqTM6zLQdy3ETqO6stXCwrBFTFaKQeJkX4wwssAMeta || {},
    component: () => import("/usr/src/app/pages/claim-form-pro.vue")
  },
  {
    name: "locale-contacts",
    path: "/:locale/contacts",
    meta: indexQ6GMvaN00UbY4hur5ZSdvVsVVGs3YNtH5rSLFnbd_6EMeta || {},
    component: () => import("/usr/src/app/pages/contacts/index.vue")
  },
  {
    name: "locale-dealzone",
    path: "/:locale/dealzone",
    meta: index_9yHCMiXOR_45w3nsScfz2IHZO6QiRAHRQevko7x1nUIUMeta || {},
    component: () => import("/usr/src/app/pages/dealzone/index.vue")
  },
  {
    name: "locale-invoice-accept",
    path: "/:locale/invoice/accept",
    meta: acceptX4knTauEjWk9JY_zixOxNpphg3bO5QiPbpq7MDzf3NUMeta || {},
    component: () => import("/usr/src/app/pages/invoice/accept.vue")
  },
  {
    name: "locale-payment-accept",
    path: "/:locale/payment/accept",
    meta: acceptSDeCHcFqnDWT_AoZvUuTC5kgUwSkvKLoIMHyHvu0KHsMeta || {},
    component: () => import("/usr/src/app/pages/payment/accept.vue")
  },
  {
    name: "locale-register",
    path: "/:locale/register",
    meta: indexZD4lmZeHNbgAJdSp25r_Wap6KrejWKH0HywWvtSyP0UMeta || {},
    component: () => import("/usr/src/app/pages/register/index.vue")
  },
  {
    name: "locale-site-pro",
    path: "/:locale/site-pro",
    meta: indexqdDtuZZGESq61iOmdhmp_45sb_DJveaxaVxDQ_45ZrsP8FAMeta || {},
    component: () => import("/usr/src/app/pages/site-pro/index.vue")
  },
  {
    name: "locale-tracking",
    path: "/:locale/tracking",
    meta: indexK_45mrHozcdij_45uH8reV_MEyV_45NzXk355V1GQ9Dbli7esMeta || {},
    component: () => import("/usr/src/app/pages/tracking/index.vue")
  },
  {
    name: "locale-invoice-decline",
    path: "/:locale/invoice/decline",
    meta: decliney79Yqmk9EpqQpIhSuYjVzy163NrH7exHC4x7XQsU4DMMeta || {},
    component: () => import("/usr/src/app/pages/invoice/decline.vue")
  },
  {
    name: "locale-my-orders",
    path: "/:locale/my-orders",
    meta: indexROTz5finYF5_j3Pt7XtreI5NTtbtknX_45zLxWFQiAqJgMeta || {},
    component: () => import("/usr/src/app/pages/my-orders/index.vue")
  },
  {
    name: "locale-payment-decline",
    path: "/:locale/payment/decline",
    meta: declinexvQC7dxwOdy5fjygJgIT3rJj8jla450ZNEy7FxhwwIIMeta || {},
    component: () => import("/usr/src/app/pages/payment/decline.vue")
  },
  {
    name: "locale-confirm-slug",
    path: "/:locale/confirm/:slug?",
    meta: _91_91slug_93_93PXefAvRvRrD6c4RIrEEP_45u_UAeBjt9LBU2n9iLCwWysMeta || {},
    component: () => import("/usr/src/app/pages/confirm/[[slug]].vue")
  },
  {
    name: "locale-order-form",
    path: "/:locale/order-form",
    meta: indexmnsZT4ih3k_45jXR8WcxBZBDtTPB_C1Y5WYNmpIGS8bB4Meta || {},
    component: () => import("/usr/src/app/pages/order-form/index.vue")
  },
  {
    name: "locale-order-successful",
    path: "/:locale/order-successful",
    meta: order_45successful2eaUNAt_45EOU1aygcCQH2xohESEqnR9G_pThsO61R_45G8Meta || {},
    component: () => import("/usr/src/app/pages/order-successful.vue")
  },
  {
    name: "locale-payment-slug",
    path: "/:locale/payment/:slug?",
    meta: _91_91slug_93_93FzCbuEHRtDcLJwiJsa1pTBTIhm5Z4dK7xrP9cLI6zZ8Meta || {},
    component: () => import("/usr/src/app/pages/payment/[[slug]].vue")
  },
  {
    name: "locale-success-slug",
    path: "/:locale/success/:slug?",
    meta: _91_91slug_93_93xgkmO_45d2xgLMJHj_vTZivkxFa8vu_eFTsmzdZ_45YGWocMeta || {},
    component: () => import("/usr/src/app/pages/success/[[slug]].vue")
  },
  {
    name: "locale-checkout-slug",
    path: "/:locale/checkout/:slug?",
    meta: _91_91slug_93_93mfh_ddLJR_45lhvSnBAbPnECTkL96rT7XH_456wzO2x6CMcMeta || {},
    component: () => import("/usr/src/app/pages/checkout/[[slug]].vue")
  },
  {
    name: "locale-marketplace",
    path: "/:locale/marketplace",
    meta: indexnsl_tZSTRK0iHJvhcKq_45PDBBxOTMS0lxZTsIqhgg98oMeta || {},
    component: () => import("/usr/src/app/pages/marketplace/index.vue")
  },
  {
    name: "locale-user-account",
    path: "/:locale/user-account",
    meta: indexZkfLdxBIxziNWE6BzJ4CTAKfqgenkyG1rMNtoxOR0QcMeta || {},
    component: () => import("/usr/src/app/pages/user-account/index.vue")
  },
  {
    name: "locale-my-orders-slug",
    path: "/:locale/my-orders/:slug(.*)*",
    meta: _91_46_46_46slug_93fA1K73vh2O__wpmvdrMRC61kYP4XLMtluku3QCmXVAwMeta || {},
    component: () => import("/usr/src/app/pages/my-orders/[...slug].vue")
  },
  {
    name: "locale-reservation-success",
    path: "/:locale/reservation/success",
    meta: successdPPYc3XYEvjazZBZmlOMN8TH8morYDOOXC60oEOnvpoMeta || {},
    component: () => import("/usr/src/app/pages/reservation/success.vue")
  },
  {
    name: "locale-unsupported-browser",
    path: "/:locale/unsupported-browser",
    meta: unsupported_45browserJT_45rVOpsUVaHhFshp10whMb6lIdfbtkwvDRcvk_45BOIAMeta || {},
    component: () => import("/usr/src/app/pages/unsupported-browser.vue")
  },
  {
    name: "locale-privacy-policy",
    path: "/:locale/privacy-policy",
    meta: indexV3keO9i30VjIGfS1JklNbFCLHu93Km5X_45K9FD62H_i8Meta || {},
    component: () => import("/usr/src/app/pages/privacy-policy/index.vue")
  },
  {
    name: "locale-create-order-slug",
    path: "/:locale/create-order/:slug(.*)*",
    meta: _91_46_46_46slug_93bJfjcSmPyANKO9Nvl8fsGEzfre_XxVxdmjDbe_MRKkwMeta || {},
    component: () => import("/usr/src/app/pages/create-order/[...slug].vue")
  },
  {
    name: "locale-site-pro-delivery",
    path: "/:locale/site-pro-delivery",
    meta: indextCDMJjLU6HgoAgAihBEEMu4VyJ7NS2zK_i43YcvP_ZEMeta || {},
    component: () => import("/usr/src/app/pages/site-pro-delivery/index.vue")
  },
  {
    name: "locale-delivery-addresses",
    path: "/:locale/delivery-addresses",
    meta: indexCxMSchgRpTGp3uFVrqOFXy58Y3pxatgetJKS_45O0MvvAMeta || {},
    component: () => import("/usr/src/app/pages/delivery-addresses/index.vue")
  },
  {
    name: "locale-iphone-reservation",
    path: "/:locale/iphone-reservation",
    meta: indexAKi0q5fmY1zcQW_CMZoENv3Jsy_TA153g_8H04Esb9YMeta || {},
    component: () => import("/usr/src/app/pages/iphone-reservation/index.vue")
  },
  {
    name: "locale-market-product-slug",
    path: "/:locale/market/product/:slug(.*)*",
    component: () => import("/usr/src/app/pages/market/product/[...slug].vue")
  },
  {
    name: "locale-order-form-summary",
    path: "/:locale/order-form/summary",
    meta: indexQwwG2bX5qiWOJdk_45WtqWU9tHZySzOU8F7NCdCH7NN6wMeta || {},
    component: () => import("/usr/src/app/pages/order-form/summary/index.vue")
  },
  {
    name: "locale-purchase-agreement",
    path: "/:locale/purchase-agreement",
    meta: indexOm2FQi1kF_bywg7pe_7xMSfJ40sHJ50Am4XNT_TutMQMeta || {},
    component: () => import("/usr/src/app/pages/purchase-agreement/index.vue")
  },
  {
    name: "locale-reservation-policy",
    path: "/:locale/reservation-policy",
    meta: indexIy4fmF2rXQSX0kl_455zojGRk59eQZiQ3MaGo_psmxyjwMeta || {},
    component: () => import("/usr/src/app/pages/reservation-policy/index.vue")
  },
  {
    name: "locale-site-pro-payment-id",
    path: "/:locale/site-pro-payment/:id(.*)*",
    meta: _91_46_46_46id_93ODBAiS3qqex7f_DgxzHBkFnPjyjS_45HFUO7Ey9SAxl0EMeta || {},
    component: () => import("/usr/src/app/pages/site-pro-payment/[...id].vue")
  },
  {
    name: "locale-account-information",
    path: "/:locale/account-information",
    meta: indext5SkrhmkX9t59W4CPgaftuV9_45_45u690vTImE6czlTvaMMeta || {},
    component: () => import("/usr/src/app/pages/account-information/index.vue")
  },
  {
    name: "locale-password-reset-token",
    path: "/:locale/password-reset/:token(.*)*",
    meta: _91_46_46_46token_93hx_45yjPPpR_45KPk0_CoFoS6NhfPF57cVowMT_45edROkHbQMeta || {},
    component: () => import("/usr/src/app/pages/password-reset/[...token].vue")
  },
  {
    name: "locale-iphone-reservation-confirm-id",
    path: "/:locale/iphone-reservation/confirm/:id()",
    meta: _91id_93OJ56Afegb3RMtmxRghDvwUXLeWkezxAIjX6N7Z3XasMMeta || {},
    component: () => import("/usr/src/app/pages/iphone-reservation/confirm/[id].vue")
  },
  {
    name: "locale-order-additional-info-needed-slug",
    path: "/:locale/order-additional-info-needed/:slug(.*)*",
    meta: _91_46_46_46slug_93ynHhnfxt_AoE3NrkUyBIHpmmtdOxju7_UJCy0BEDFvQMeta || {},
    component: () => import("/usr/src/app/pages/order-additional-info-needed/[...slug].vue")
  }
]